import Vue from 'vue'
import Router from 'vue-router'
import Page from '@/components/Page'
import TeacherGuide from '@/components/TeacherGuide'

Vue.use(Router)

export const router = new Router({
  routes: [
    {
        path: '/teacher-guide',
        name: 'Teacher',
        component: TeacherGuide
    },
    {
        path: '/guide-pédagogique',
        name: 'Teacher',
        component: TeacherGuide
    },
    {
      path: '/*',
      name: 'Page',
      component: Page
  }
  ]
})